import { HttpError } from './http';

function mapCodeToMessage(code?: string, details?: any): string | null {
  if (!code) return null;
  switch (code) {
    case 'serverUrl_not_set':
      return 'Не указан адрес сервера';
    case 'invalid_email':
      return 'Неверный формат email';
    case 'invalid_name':
      return 'Введите корректное имя';
    case 'invalid_credentials':
      return 'Неверный логин или пароль';
    case 'bootstrap_already_completed':
      return 'Первичная настройка уже выполнена. Войдите в систему.';
    case 'role_exists':
      return 'Такая роль уже существует';
    case 'role_in_use':
      return 'Нельзя удалить роль: она назначена пользователям';
    case 'role_protected':
      return 'Нельзя удалить системную роль';
    case 'position_in_use':
      return 'Нельзя удалить должность: она назначена пользователям';
    case 'invalid_position':
      return 'Некорректная должность';
    case 'vacation_overlap':
      return 'Нельзя добавить отпуск: период пересекается с уже существующим';
    case 'invalid_date_range':
      return 'Некорректный диапазон дат';
    case 'invalid_date':
      return 'Некорректная дата';
    case 'invalid_time_range':
      return 'Некорректный диапазон времени';
    case 'invalid_time_step':
      return 'Время должно быть указано с шагом 15 минут';
    case 'reason_required':
      return 'Укажите причину';
    case 'too_late_to_cancel':
      return 'Нельзя отменить: дата уже прошла';
    case 'cancel_already_requested':
      return 'Отмена уже запрошена и ожидает согласования';
    case 'already_canceled':
      return 'Отгул уже отменён';
    case 'already_decided':
      return 'Заявка уже обработана';
    case 'invalid_days':
      return 'Некорректное количество дней';
    case 'invalid_user':
      return 'Некорректный пользователь';
    case 'date_in_past':
      return 'Задним числом нельзя';
    case 'cannot_delete_bot':
      return 'Нельзя удалить бота';
    case 'cannot_fire_bot':
      return 'Нельзя уволить бота';
    case 'user_not_fired':
      return 'Сначала нужно уволить пользователя';
    case 'invalid_timezone':
      return 'Неверный часовой пояс';
    case 'invalid_max_file_size':
      return 'Некорректный размер файла (1-10240 МБ)';
    case 'invalid_server_base_url':
      return 'Некорректный адрес сервера';
    case 'duplicate_server_base_url':
      return 'Основной и резервный адреса не должны совпадать';
    case 'invalid_target_department':
      return 'Неверный отдел получателя';
    case 'invalid_priority':
      return 'Неверный приоритет';
    case 'unsupported_file_type':
      return 'Неподдерживаемый тип файла';
    case 'no_files':
      return 'Файлы не найдены';
    case 'journal_entry_required':
      return 'Заполните запись за день';
    case 'journal_template_title_required':
      return 'Введите текст шаблона';
    case 'journal_entry_too_large':
      return 'Запись слишком большая';
    case 'journal_entries_not_found':
      return 'За выбранный период нет записей журнала';
    case 'journal_openrouter_not_configured':
      return 'Генерация отчёта недоступна: OpenRouter не настроен';
    case 'journal_report_invalid_ai_payload':
      return 'ИИ вернул некорректный ответ. Попробуйте сформировать отчёт ещё раз';
    case 'journal_report_generation_failed':
      return String(details?.message || 'Не удалось сформировать отчёт');
    case 'weak_password': {
      const min = details?.minLen;
      return min ? `Пароль слишком короткий (минимум ${min} символов)` : 'Слишком простой пароль';
    }
    case 'old_password_required':
      return 'Укажите старый пароль';
    case 'invalid_old_password':
      return 'Неверный старый пароль';
    case 'bad_id':
      return 'Некорректный идентификатор';
    case 'no_fields':
      return 'Нет полей для обновления';
    case 'not_found':
      return 'Не найдено';
    case 'forbidden':
      return 'Недостаточно прав';
    case 'unauthorized':
      return 'Требуется вход';
    case 'bad_request': {
      const miss = details?.missing;
      if (Array.isArray(miss) && miss.length) return `Заполните обязательные поля: ${miss.join(', ')}`;
      return 'Некорректный запрос';
    }
    case 'llm_test_failed':
      return String(details?.message || 'Не удалось проверить подключение ИИ');
    default:
      // Some libs may pass plain text in error as a code (e.g. Multer 413)
      if (code.toLowerCase() === 'file too large') return 'Файл слишком большой';
      return null;
  }
}

export function toUserError(err: unknown, fallback = 'Произошла ошибка') {
  let code: string | undefined;
  let rid: string | undefined;
  let details: any;
  if (err instanceof HttpError) {
    code = err.code;
    rid = err.rid;
    details = err.details;
  }
  const message = mapCodeToMessage(code, details) ?? fallback;
  return { message, code, rid };
}
